"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _identity = _interopRequireDefault(require("lodash/identity"));
var validateRequiredOptions = _interopRequireWildcard(require("./validateRequiredOptions"));
var loadOptionsSuccess = _interopRequireWildcard(require("./loadOptionsSuccess"));
var executeRulesSuccess = _interopRequireWildcard(require("./executeRulesSuccess"));
var _actionTypes = require("../../actions/actionTypes");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var allIdsActions = (0, _defineProperty2["default"])({}, _actionTypes.LOAD_OPTIONS_SUCCESS, loadOptionsSuccess.allIds);
var byIdActions = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _actionTypes.VALIDATE_REQUIRED_OPTIONS, validateRequiredOptions.byId), _actionTypes.LOAD_OPTIONS_SUCCESS, loadOptionsSuccess.byId), _actionTypes.EXECUTE_RULES_SUCCESS, executeRulesSuccess.byId);
var topLevelOptionsActions = (0, _defineProperty2["default"])({}, _actionTypes.LOAD_OPTIONS_SUCCESS, loadOptionsSuccess.topLevelOptions);
var byId = function byId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var act = byIdActions[action.type] || _identity["default"];
  return act(state, action);
};
var allIds = function allIds() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var act = allIdsActions[action.type] || _identity["default"];
  return act(state, action);
};
var topLevelOptions = function topLevelOptions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var act = topLevelOptionsActions[action.type] || _identity["default"];
  return act(state, action);
};
var optionsReducer = function optionsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    allIds: [],
    topLevelOptions: []
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === _actionTypes.CLEAR_STATE) {
    return {
      allIds: [],
      topLevelOptions: []
    };
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    allIds: allIds(state, action),
    topLevelOptions: topLevelOptions(state, action)
  }, byId(state, action));
};
var _default = exports["default"] = optionsReducer;
//# sourceMappingURL=index.js.map